import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'fas fa-building',
      titleKey: 'service-formation-title',
      descKey: 'service-formation-desc'
    },
    {
      icon: 'fas fa-user-tie',
      titleKey: 'service-nominee-title',
      descKey: 'service-nominee-desc'
    },
    {
      icon: 'fas fa-university',
      titleKey: 'service-banking-title',
      descKey: 'service-banking-desc'
    },
    {
      icon: 'fas fa-shield-alt',
      titleKey: 'service-compliance-title',
      descKey: 'service-compliance-desc'
    },
    {
      icon: 'fas fa-file-contract',
      titleKey: 'service-legal-title',
      descKey: 'service-legal-desc'
    },
    {
      icon: 'fas fa-headset',
      titleKey: 'service-support-title',
      descKey: 'service-support-desc'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>{t('services-title')}</h2>
          <p>{t('services-subtitle')}</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              style={{ animationDelay: `${(index + 1) * 0.1}s` }}
            >
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{t(service.titleKey)}</h3>
              <p>{t(service.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 